import React from 'react';
import { Redirect } from 'react-router-dom';

import Routes from 'routes';

import { AURoutesGenerator } from '@assertiva/assertiva-ui';

import Office from './AppLayout';

import ErrorInterceptor from '@hoc/error';

function PrivateRoute() {
  return (
    <ErrorInterceptor>
      <AURoutesGenerator
        routes={[...Routes()]}
        defaultPrivateRedirect="/"
        defaultPublicRedirect="/"
        NotFoundComponent={() => <Redirect to="/" />}
        PrivateLayout={(props) => <Office {...props} />}
      />
    </ErrorInterceptor>
  );
}

export default PrivateRoute;
